import { render, staticRenderFns } from "./SimulationLearners.vue?vue&type=template&id=3cb03948&scoped=true"
import script from "./SimulationLearners.vue?vue&type=script&lang=js"
export * from "./SimulationLearners.vue?vue&type=script&lang=js"
import style0 from "./SimulationLearners.vue?vue&type=style&index=0&id=3cb03948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb03948",
  null
  
)

export default component.exports